// src/pages/Home.jsx
import Banner from "../components/landing/Banner";
import Hero from "../components/landing/Hero";
import PartnerLogoCloud from "../components/landing/PartnerLogoCloud";
import React from "react";

export default function Home(props) {
  return (
   <div className="flex flex-col h-full ">
      <Banner />

      {/* Hero + logos share all the remaining space */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Hero {...props} />
      </div>
    </div>
  );
}
